var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 33.5,
    viewBox: "0 0 38 33.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wallet",
    "data-name": "Icon awesome-wallet",
    d: "M32.428,9H5.625a1.125,1.125,0,0,1,0-2.25h27A1.125,1.125,0,0,0,33.75,5.625,3.375,3.375,0,0,0,30.375,2.25H4.5A4.5,4.5,0,0,0,0,6.75v22.5a4.5,4.5,0,0,0,4.5,4.5H32.428A3.481,3.481,0,0,0,36,30.375v-18A3.481,3.481,0,0,0,32.428,9ZM29.25,23.625a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,29.25,23.625Z",
    transform: "translate(1 -1.25)",
    fill: "none",
    stroke: "#bc1e2c",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cd260ef24f330ca72cf988b6cb71dee5.svg";
export { ForwardRef as ReactComponent };